import { Box, Skeleton } from '@mui/material';
import type { ReactNode } from 'react';

interface IProps {
  text: string;
  variant?: 'highlight' | 'neutral';
  loading?: boolean;
}

const InsightCallout = ({ text, variant = 'neutral', loading }: IProps): ReactNode => {
  if (loading) {
    return (
      <Box sx={{ mt: 2, mb: 0.5, px: 2 }}>
        <Skeleton variant='text' width='75%' />
      </Box>
    );
  }
  if (!text) return null;
  return (
    <Box
      sx={{
        mt: 2,
        mb: 0.5,
        px: 2,
        fontSize: 13,
        lineHeight: 1.5,
        color: variant === 'highlight' ? 'primary.main' : 'text.secondary',
        '@media print': { fontSize: 11, mt: 0.5, mb: 0 },
      }}
    >
      <Box component='span' sx={{ fontWeight: 600 }}>
        Insight:
      </Box>{' '}
      {text}
    </Box>
  );
};

export default InsightCallout;
